import {useQueryClient} from '@tanstack/react-query';
import {Button} from 'antd';
import {useState} from 'react';

import {appRoute} from '../../../../app-route';
import {CreateEventFormModal} from '../../../../component/events/event-form/create-event-form-modal';
import {CreatePromotionFormModal} from '../../../../component/promotions/promotion-form/create-promotion-form-modal';
import {CreateYandexStoryFormModal} from '../../../../component/stories/yandex-story-form/create-yandex-story-form-modal';
import {NavigationLink} from '../../../../layout/navigation-link/navigation-link';
import {Locale} from '../../../../provider/locale/locale';
import {YandexStoryTypeEnum} from '../../../../service/yandex-stories/yandex-stories-type';
import {PostsTabEnum} from '../posts-const';

type PostsCreateButtonPropsType = {
    activeTab: PostsTabEnum;
    isLicenseExpired: boolean;
};

export function PostsCreateButton({activeTab, isLicenseExpired}: PostsCreateButtonPropsType): JSX.Element {
    const {postsManagementCreatePost} = appRoute;
    const queryClient = useQueryClient();
    const [isCreateStoryModalOpen, setIsCreateStoryModalOpen] = useState(false);
    const [isCreatePromotionModalOpen, setIsCreatePromotionModalOpen] = useState(false);
    const [isCreateEventModalOpen, setIsCreateEventModalOpen] = useState(false);

    if (activeTab === PostsTabEnum.Events) {
        return (
            <>
                <Button disabled={isLicenseExpired} onClick={() => setIsCreateEventModalOpen(true)} type="primary">
                    <Locale stringKey="POSTS__TAB__CREATE_EVENT" />
                </Button>

                {isCreateEventModalOpen && (
                    <CreateEventFormModal
                        onCreateSuccess={() => queryClient.invalidateQueries(['events'])}
                        setIsOpen={setIsCreateEventModalOpen}
                    />
                )}
            </>
        );
    }

    if (activeTab === PostsTabEnum.Promotions) {
        return (
            <>
                <Button disabled={isLicenseExpired} onClick={() => setIsCreatePromotionModalOpen(true)} type="primary">
                    <Locale stringKey="POSTS__TAB__CREATE_PROMOTION" />
                </Button>

                {isCreatePromotionModalOpen && (
                    <CreatePromotionFormModal
                        onCreateSuccess={() => queryClient.invalidateQueries(['promotions'])}
                        setIsOpen={setIsCreatePromotionModalOpen}
                    />
                )}
            </>
        );
    }

    if (activeTab === PostsTabEnum.Stories) {
        return (
            <>
                <Button disabled={isLicenseExpired} onClick={() => setIsCreateStoryModalOpen(true)} type="primary">
                    <Locale stringKey="POSTS__TAB__CREATE_STORY" />
                </Button>

                {isCreateStoryModalOpen && (
                    <CreateYandexStoryFormModal
                        onCreateSuccess={() => queryClient.invalidateQueries(['yandex-stories'])}
                        setIsOpen={setIsCreateStoryModalOpen}
                        type={YandexStoryTypeEnum.Story}
                    />
                )}
            </>
        );
    }

    return (
        <NavigationLink to={postsManagementCreatePost.path}>
            <Button disabled={isLicenseExpired} type="primary">
                <Locale stringKey="POSTS__TAB__CREATE_POST" />
            </Button>
        </NavigationLink>
    );
}
